// Generates a custom element where admins can adjust associated auto groups for webhooks and audio files

class GroupDetailRow extends HTMLElement {
  constructor() {
    super();
    this.show_industries = false
  }
  async connectedCallback() {
    this.innerHTML = "Loading...";
    // Group data
    let group_data_binder = new DataBinder("/admin/groups.json", true);
    await group_data_binder.fetchData();
    let group_data = group_data_binder.data;    
    let group_options = group_data.map(group => `<option ${this.current_selected_groups.includes(group.id) ? "selected": ""} value="${group.id}">${group.name}</option>`).join("");
    

    // Industry data
    let industry_options = null;
    if(this.show_industries) {
      let industry_data_binder = new DataBinder("/admin/industries.json", true);
      await industry_data_binder.fetchData();
      let industry_data = industry_data_binder.data;    
      industry_options = industry_data.map(industry => `<option ${this.current_selected_industries.includes(industry.id) ? "selected": ""} value="${industry.id}">${industry.display_name}</option>`).join("");
    }

    let unique_hash = Math.random().toString(36).substr(2,9);
    this.innerHTML = 
    // Groups
    `<div class="row">
      <div class="col-sm-12">
        <h3>Accessible Groups</h3>
      </div>  
    </div>
    <div class="row">
      <div class="col-sm-4">
        <span>Available</span>
        <select name="from[]" class="js-multiselect form-control" size="8" multiple="multiple">
          ${group_options}
        </select>
      </div>
      <div class="col-sm-4">
        </br>
        </br>
        <button type="button" id="js_right_All_1" class="btn btn-block"><i class="glyphicon glyphicon-forward"></i></button>
        <button type="button" id="js_right_Selected_1" class="btn btn-block"><i class="glyphicon glyphicon-chevron-right"></i></button>
        <button type="button" id="js_left_Selected_1" class="btn btn-block"><i class="glyphicon glyphicon-chevron-left"></i></button>
        <button type="button" id="js_left_All_1" class="btn btn-block"><i class="glyphicon glyphicon-backward"></i></button>
      </div>
        <div class="col-sm-4">
          <span>Selected</span>
          <select name="to[]" id="js_multiselect_to_1" class="form-control" size="8" multiple="multiple"></select>
        </div>
      </div>
    <div class="row">                                                                        

    </div>` +
    // Industries
    (!this.show_industries ? "" :
    `<div class="row">
      <div class="col-sm-12">
        <h3>Accessible Industries</h3>
      </div>  
    </div>
    <div class="row">
      <div class="col-sm-4">
        <span>Available</span>
        <select name="from[]" class="_${unique_hash}_js-multiselect form-control" size="8" multiple="multiple">
          ${industry_options}
        </select>
      </div>
      <div class="col-sm-4">
        </br>
        </br>
        <button type="button" id="_${unique_hash}_js_right_All_1" class="btn btn-block"><i class="glyphicon glyphicon-forward"></i></button>
        <button type="button" id="_${unique_hash}_js_right_Selected_1" class="btn btn-block"><i class="glyphicon glyphicon-chevron-right"></i></button>
        <button type="button" id="_${unique_hash}_js_left_Selected_1" class="btn btn-block"><i class="glyphicon glyphicon-chevron-left"></i></button>
        <button type="button" id="_${unique_hash}_js_left_All_1" class="btn btn-block"><i class="glyphicon glyphicon-backward"></i></button>
      </div>
        <div class="col-sm-4">
          <span>Selected</span>
          <select name="to[]" id="_${unique_hash}_js_multiselect_to_1" class="form-control" size="8" multiple="multiple"></select>
        </div>
      </div>`) +
    `<div class="row">                                                                        
      <button class="btn btn-primary pull-right detail-row-button" id="industry-save">Save</button>
      <button class="btn btn-outline-secondary pull-right detail-row-button" id="industry-cancel">Cancel</button>
    </div>`;

    $(this.querySelector("select.js-multiselect")).multiselect({
      right: "#js_multiselect_to_1",
      rightAll: "#js_right_All_1",
      rightSelected: "#js_right_Selected_1",
      leftSelected: "#js_left_Selected_1",
      leftAll: "#js_left_All_1"
    });

    $(this.querySelector(`select._${unique_hash}_js-multiselect`)).multiselect({
      right: `#_${unique_hash}_js_multiselect_to_1`,
      rightAll: `#_${unique_hash}_js_right_All_1`,
      rightSelected: `#_${unique_hash}_js_right_Selected_1`,
      leftSelected: `#_${unique_hash}_js_left_Selected_1`,
      leftAll: `#_${unique_hash}_js_left_All_1`
    });

    $("#js_right_Selected_1").click();
    $(`#_${unique_hash}_js_right_Selected_1`).click();

    this.querySelector(".btn-primary").addEventListener("click", async function(e) {
      e.preventDefault();
      let template_body = {}

      let group_selected_options = document.getElementById("js_multiselect_to_1").options;
      let group_save_selected = [];
      group_selected_options.forEach(element => {
        group_save_selected.push(parseInt(element.value));
      });
      template_body.groups = group_save_selected;
      
      if(this.show_industries) {
        let industry_selected_options = document.getElementById(`_${unique_hash}_js_multiselect_to_1`).options;
        let industry_save_selected = [];
        industry_selected_options.forEach(element => {
          industry_save_selected.push(parseInt(element.value));
        });
        template_body.industries = industry_save_selected;
      }

      let saved_items = await fetch(`${this.url}`, {
        headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
                  'Content-type': 'application/json'},
        method: 'post',
        body: JSON.stringify(template_body)
      });
      let response = await saved_items.json();
      if (response.success) {
        Common.notify('Auto Groups and Industries updated', 'success')
        this.closeRow(e)
      } else {
        Common.notify('Unable to update', 'danger');
      }
    }.bind(this));
    this.querySelector("#industry-cancel").addEventListener("click", this.closeRow);
  }

  closeRow(e) {
    e.preventDefault();
    this.closest("table").querySelector("tr.shown td.details-control").click();
  }
}

customElements.define("group-detail-row", GroupDetailRow);